export const environment = {
  production: true,
  apiUrl: 'https://api.myhop.ch/',
  // apiUrl: 'https://api.appemporio.ch/',
  imageUrl: 'https://hop-delivery.s3.eu-central-1.amazonaws.com/',
};
